import type { AxiosResponse } from "axios";

import ApiClient from "./ApiClient";

class ExternalItemsService extends ApiClient {
  constructor() {
    super("/external_items");
  }

  bulkVerifyUrls(urls: string[]): Promise<AxiosResponse<void>> {
    return this.post<void>(`/bulk_verify_urls`, { params: { urls } });
  }
}

export default new ExternalItemsService();
